// fontFamily = 'oswald', fontSize = '13', fontWeight, children;
export type AppButtonProps = {
  children: React.ReactNode;
  id?: string;
  type?: 'button' | 'submit' | 'reset';
  onClick?: (event?: React.MouseEvent<HTMLButtonElement>) => void;
  fontFamily?: 'oswald' | 'lato';
  fontWeight?: '400' | '500' | '600' | '700';
  fontSize?: '13' | '14' | '15' | '16' | '17' | '18' | '19' | '20' | '21' | '22' | '23' | '24';
  variant?:
    | 'primary'
    | 'secondary'
    | 'success'
    | 'danger'
    | 'warning'
    | 'info'
    | 'light'
    | 'dark'
    | 'transparent'
    | 'outline-primary'
    | 'outline-secondary'
    | 'outline-success'
    | 'outline-danger'
    | 'outline-warning'
    | 'outline-info'
    | 'outline-light'
    | 'outline-dark'
    | 'link'
    | 'white';
  className?: string;
  disabled?: boolean;
  dataTestId?: string;
  args?: any;
  width?: string;
  role?: string;
  uppercase?: boolean;
};

export const AppButton = ({
  children,
  variant = 'primary',
  type = 'button',
  onClick = () => {},
  fontFamily = 'oswald',
  fontSize = '13',
  fontWeight = '500',
  disabled = false,
  className = '',
  dataTestId = '',
  width = '',
  role = 'button',
  uppercase = true,
  ...args
}: AppButtonProps) => {
  return (
    <button
      type={type}
      className={`btn btn-${variant} font-${fontFamily} font-${fontSize} font-${fontWeight} d-flex align-items-center justify-content-center ${uppercase ? 'text-uppercase' : ''}  ${
        disabled ? 'disabled cursor-not-allowed' : ''
      } ${className} ${width ? 'w-' + width : ''} `}
      onClick={(e) => onClick(e)}
      disabled={disabled}
      data-test={dataTestId || 'testing-button'}
      role={role}
      {...args}
    >
      {children}
    </button>
  );
};

export default AppButton;
